import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { TrendingUp, Users, Award } from "lucide-react";
import { useTheme } from "@/hooks/useTheme";
import fitlinkLogo from "@/assets/fitlink-logo-blue-80.webp";

const Index = () => {
  const navigate = useNavigate();
  const { theme } = useTheme();

  useEffect(() => {
    // Check if user is already logged in
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) {
        navigate("/dashboard");
      }
    });
  }, [navigate]);

  return (
    <main className="min-h-screen bg-gradient-hero">
      {/* Hero Section */}
      <div className="container mx-auto px-4 py-16">
        <div className="text-center max-w-4xl mx-auto animate-fade-in">
          <img 
            src={fitlinkLogo} 
            alt="FITLINK logo" 
            className="w-20 h-20 mx-auto mb-6 rounded-2xl" 
            width="80" 
            height="80"
            fetchPriority="high"
            loading="eager"
          />
          <h1 className="text-5xl md:text-6xl font-bold mb-6 text-primary">
            FITLINK
          </h1>
          <p className="text-xl md:text-2xl text-muted-foreground mb-8">
            Track your workouts, share your progress, and achieve your fitness goals together
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              size="lg"
              className="text-lg px-8"
              onClick={() => navigate("/auth")}
            >
              Get Started
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="text-lg px-8"
              onClick={() => navigate("/auth")}
            >
              Sign In
            </Button>
          </div>
        </div>

        {/* Features */}
        <div className="grid md:grid-cols-3 gap-8 mt-24 max-w-5xl mx-auto">
          <div className="text-center p-6 rounded-2xl bg-card/50 backdrop-blur-sm border border-border">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-lg bg-primary/20 mb-4">
              <TrendingUp className="w-6 h-6 text-primary" />
            </div>
            <h2 className="text-xl font-semibold mb-2">Track Progress</h2>
            <p className="text-muted-foreground">
              Log exercises, sets, reps, and weight. Visualize your strength gains over time.
            </p>
          </div>

          <div className="text-center p-6 rounded-2xl bg-card/50 backdrop-blur-sm border border-border">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-lg bg-primary/20 mb-4">
              <Users className="w-6 h-6 text-primary" />
            </div>
            <h2 className="text-xl font-semibold mb-2">Social Feed</h2>
            <p className="text-muted-foreground">
              Share workouts with friends, get motivated by the community, and celebrate wins together.
            </p>
          </div>

          <div className="text-center p-6 rounded-2xl bg-card/50 backdrop-blur-sm border border-border">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-lg bg-primary/20 mb-4">
              <Award className="w-6 h-6 text-primary" />
            </div>
            <h2 className="text-xl font-semibold mb-2">Achieve Goals</h2>
            <p className="text-muted-foreground">
              Set targets, track calories, monitor duration, and unlock your full potential.
            </p>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Index;
